<template>
  <div>
    <div class="row text-white inner-row" style="background: #00bbff">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b>{{object.category.name + '(' + (object.product ? fieldView(object.product.name) : 'номенклатура не определена') + ')'}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
      </div>
    </div>

    <simple-row :name="'Наименование'" :value="object.product ? fieldView(object.product.name) + '(' + fieldView(object.product.code) + ')' : '-'"></simple-row>
    <simple-row :name="'Категория'" :value="fieldView(object.category.name)"></simple-row>
    <simple-row :name="'Количество'" :value="fieldView(object.quantity)"></simple-row>
    <simple-row :name="'Стоимость, руб.'" :value="object.price ? fieldView(object.price) : 'Нет данных'"></simple-row>

    <div v-if="deleteAllowed" class="row" style="padding-bottom: 15px">
      <div class="col-md-12" style="text-align: right">
        <base-button @click="kill" :size="'sm'" type="warning" fill>Удалить</base-button>
      </div>
    </div>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";
 import {userService} from "@/services/user.service";

 export default {
   components: {
     SimpleRow
   },
   props:{
     item: {}
   },
   data() {
     return {
       tableKey: 0,
       object: this.item.object,
       showCalls: false,
       showIPRs: false,
       deleteAllowed: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     },
     async kill() {
       if (await this.$repo.killObject(this.object, 'item')) {
         this.$emit('delete');
       }
     }
   },
   mounted() {
     this.deleteAllowed = userService.isDeleteAllowed();
   }
 }
</script>
<style>
</style>
